/* eslint-disable @typescript-eslint/no-explicit-any */

export const aspnet = () => {
  const ASPNET = {
    case_insensitive: true,
    subLanguage: "html",
    contains: [
      {
        className: "csharp",
        begin: /<%=?/,
        end: /%>/,
        subLanguage: "csharp",
      },
      {
        className: "csharp",
        begin: /<script\s+runat="server">/,
        end: /<\/script>/,
        subLanguage: "csharp",
        excludeBegin: true,
        excludeEnd: true,
      },
    ],
  };
  return ASPNET;
};

export const extendMatlab = (hljs: any) => {
  const matlab = hljs.getLanguage("matlab");
  if (!matlab) return { name: "matlab", contains: [] };

  const matlabObj = {
    ...matlab,
    contains: [
      {
        className: "comment",
        begin: /%{\n?/,
        end: /\n?%}/,
        contains: [
          {
            className: "comment",
            begin: /./,
            end: /$/,
            relevance: 0,
          },
        ],
        relevance: 0,
      },
      {
        className: "comment",
        begin: /%.*/,
        relevance: 0,
      },
      {
        className: "unclosed-string",
        begin: /'[^'\n]*$|"[^'\n]*$/,
        relevance: 0,
      },
      {
        className: "string",
        begin: /'([^'\n]*)'/,
      },
      {
        className: "string",
        begin: /"(.*?)"/,
      },
      {
        className: "number",
        begin: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+)?(?:[ij])?|\b[ij]\b/,
        relevance: 0,
      },
      {
        className: "special_keywords",
        begin: /(?<=\bclose\s+)all\b/,
        relevance: 0,
      },
      {
        className: "special_keywords",
        begin: /(?<=\b(?:grid|hold)\s+)(?:on|off)\b/,
        relevance: 0,
      },
      {
        className: "syntax-error",
        begin: /SyntaxError:\s.*?(?=[\n;])/,
        relevance: 0,
      },
      {
        className: "index-end",
        begin: /(?<=\(\s*|\[\s*|\s*[:,\])]+)end(?=\s*[:,\])])/,
        relevance: 0,
        greedy: true,
      },
      {
        className: "validation-section",
        begin: /\barguments\b/,
        end: /\bend\b/,
        keywords: "arguments end",
        contains: [
          {
            className: "validationSectionSize",
            begin: /\(\d+(?:,\d+)*\)/,
          },
          {
            className: "validationSectionClass",
            begin: /\b(?:string|double|char|logical|int\d+|uint\d+|cell|table)\b/,
          },
          {
            className: "validationSectionFunctions",
            begin: /\{[^}]+\}/,
          },
          {
            className: "punctuation",
            begin: /[,;{}()]/,
          },
          {
            className: "validationSectionExcluded",
            begin: /\b[a-zA-Z_]\w*\b(?=\s*(?:\([^)]*\)\s*)?[=,;])/,
          },
          {
            className: "default-value",
            begin: /=\s*/,
            end: /$/,
            contains: [
              {
                className: "string",
                begin: /'([^'\n]*)'/,
              },
              {
                className: "string",
                begin: /"(.*?)"/,
              },
              {
                className: "number",
                begin: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+)?(?:[ij])?|\b[ij]\b/,
                relevance: 0,
              },
              {
                className: "punctuation",
                begin: /=/,
              },
            ],
          },
        ],
      },
    ],
  };
  return matlabObj;
};

export const extendJava = (hljs: any) => {
  const javaBase = hljs.getLanguage("java");
  if (!javaBase) return { name: "java", contains: [] };
  return {
    ...javaBase,
    contains: [
      ...(javaBase.contains || []),
      {
        className: "custom-keyevent",
        begin: /(?<=<)KeyEvent(?=>)/,
      },
      {
        className: "sql-keyword",
        begin: /\b(VALUES)\b/,
      },
      {
        className: "function-call",
        begin: /\b[A-Z][a-zA-Z0-9_]*\s*(?=\()/,
        relevance: 0,
      },
    ],
  };
};
